module.exports = __webpack_public_path__ + "static/media/icon_left_arrow_blue.4e27d02b.svg";